var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.tabs),function(tab,tabIndex){return [(tab)?_c('button',{key:tabIndex,class:[_vm.buttonClass, {
              _active: _vm.current === tabIndex,
              _new: false
            }],attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle(tabIndex)}}},[_c('span',[_vm._v(_vm._s(tab.name))])]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }